import { FC, HTMLAttributes } from 'react';

interface Icon extends HTMLAttributes<HTMLOrSVGElement> {
    star?: boolean;
    tickCircle?: boolean;
    tickCircleWhite?: boolean;
    starTransparent?: boolean;
    timer?: boolean;
    chartSquare?: boolean;
    archiveBook?: boolean;
    trackCode?: boolean;
    phone?: boolean;
    close?: boolean;
    bar?: boolean;
    massage?: boolean;
    charge?: boolean;
    arrowDown?: boolean;
    arrowUp?: boolean;
    arrowRight?: boolean;
    edit?: boolean;
    add?: boolean;
    note?: boolean;
    bill?: boolean;
    infoCircle?: boolean;
    logout?: boolean;
    profileUser?: boolean;
    profileCircle?: boolean;
    eyeSplash?: boolean;
    eye?: boolean;
    sms?: boolean;
}

export const Icons: FC<Icon> = ({
    star,
    tickCircle,
    tickCircleWhite,
    starTransparent,
    timer,
    chartSquare,
    archiveBook,
    trackCode,
    phone,
    close,
    bar,
    massage,
    charge,
    arrowDown,
    arrowUp,
    arrowRight,
    edit,
    add,
    note,
    bill,
    infoCircle,
    logout,
    profileUser,
    profileCircle,
    eyeSplash,
    eye,
    sms,
    ...props
}) => {
    return (
        <>
            {star && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='21'
                    height='20'
                    viewBox='0 0 21 20'
                    fill='#FFC043'
                    {...props}
                >
                    <path d='M20 8.1C20.1 7.6 19.7 7 19.2 7L13.5 6.2L10.9 0.999999C10.8 0.799999 10.7 0.699999 10.5 0.599999C10 0.299999 9.4 0.499999 9.1 0.999999L6.6 6.2L0.9 7C0.6 7 0.4 7.1 0.3 7.3C-0.1 7.7 -0.1 8.3 0.3 8.7L4.4 12.7L3.4 18.4C3.4 18.6 3.4 18.8 3.5 19C3.8 19.5 4.4 19.7 4.9 19.4L10 16.7L15.1 19.4C15.2 19.5 15.4 19.5 15.6 19.5C15.7 19.5 15.7 19.5 15.8 19.5C16.3 19.4 16.7 18.9 16.6 18.3L15.6 12.6L19.7 8.6C19.9 8.5 20 8.3 20 8.1Z' />
                </svg>
            )}
            {starTransparent && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='21'
                    height='20'
                    viewBox='0 0 21 20'
                    fill='#B8B8B8'
                    {...props}
                >
                    <path d='M20 7.66999C19.9368 7.48708 19.822 7.32642 19.6693 7.20749C19.5167 7.08857 19.3328 7.01649 19.14 6.99999L13.45 6.16999L10.9 0.999993C10.8181 0.830922 10.6902 0.688335 10.5311 0.588566C10.3719 0.488798 10.1878 0.435883 9.99998 0.435883C9.81212 0.435883 9.62806 0.488798 9.46889 0.588566C9.30971 0.688335 9.18186 0.830922 9.09998 0.999993L6.54998 6.15999L0.859977 6.99999C0.6749 7.0263 0.500902 7.10396 0.357728 7.22415C0.214554 7.34435 0.107937 7.50227 0.0499774 7.67999C-0.00307759 7.85367 -0.00783865 8.03851 0.0362052 8.21469C0.080249 8.39086 0.171435 8.55172 0.299977 8.67999L4.42998 12.68L3.42998 18.36C3.39428 18.5475 3.41297 18.7412 3.48385 18.9184C3.55473 19.0956 3.67483 19.2489 3.82998 19.36C3.98119 19.4681 4.15955 19.5319 4.34503 19.5443C4.5305 19.5566 4.71575 19.5171 4.87998 19.43L9.99998 16.76L15.1 19.44C15.2403 19.5192 15.3988 19.5605 15.56 19.56C15.7718 19.5607 15.9784 19.4942 16.15 19.37C16.3051 19.2589 16.4252 19.1056 16.4961 18.9284C16.567 18.7512 16.5857 18.5575 16.55 18.37L15.55 12.69L19.68 8.68999C19.8244 8.56767 19.9311 8.4069 19.9877 8.22634C20.0444 8.04579 20.0486 7.85287 20 7.66999ZM13.85 11.67C13.7327 11.7834 13.645 11.9238 13.5944 12.079C13.5439 12.2341 13.532 12.3992 13.56 12.56L14.28 16.75L10.52 14.75C10.3753 14.673 10.2139 14.6327 10.05 14.6327C9.88606 14.6327 9.72466 14.673 9.57998 14.75L5.81998 16.75L6.53998 12.56C6.56791 12.3992 6.55609 12.2341 6.50554 12.079C6.45499 11.9238 6.36725 11.7834 6.24998 11.67L3.24998 8.66999L7.45998 8.05999C7.62198 8.03746 7.77598 7.97553 7.90848 7.87964C8.04098 7.78376 8.14794 7.65683 8.21998 7.50999L9.99998 3.69999L11.88 7.51999C11.952 7.66683 12.059 7.79376 12.1915 7.88964C12.324 7.98553 12.478 8.04746 12.64 8.06999L16.85 8.67999L13.85 11.67Z' />
                </svg>
            )}
            {timer && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='46'
                    height='46'
                    viewBox='0 0 46 46'
                    fill='#7AB3FF'
                    {...props}
                >
                    <path d='M23.0002 43.0666C13.2188 43.0666 5.26685 35.1146 5.26685 25.3333C5.26685 15.552 13.2188 7.59998 23.0002 7.59998C32.7815 7.59998 40.7335 15.552 40.7335 25.3333C40.7335 35.1146 32.7815 43.0666 23.0002 43.0666ZM23.0002 10.4C14.7682 10.4 8.06685 17.1013 8.06685 25.3333C8.06685 33.5653 14.7682 40.2666 23.0002 40.2666C31.2322 40.2666 37.9335 33.5653 37.9335 25.3333C37.9335 17.1013 31.2322 10.4 23.0002 10.4Z' />
                    <path d='M23.0001 26.2666C22.2348 26.2666 21.6001 25.632 21.6001 24.8666V15.5333C21.6001 14.768 22.2348 14.1333 23.0001 14.1333C23.7654 14.1333 24.4001 14.768 24.4001 15.5333V24.8666C24.4001 25.632 23.7654 26.2666 23.0001 26.2666Z' />
                    <path d='M28.6 5.73329H17.4C16.6347 5.73329 16 5.09862 16 4.33329C16 3.56796 16.6347 2.93329 17.4 2.93329H28.6C29.3653 2.93329 30 3.56796 30 4.33329C30 5.09862 29.3653 5.73329 28.6 5.73329Z' />
                </svg>
            )}
            {chartSquare && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='46'
                    height='46'
                    viewBox='0 0 46 46'
                    fill='#7AB3FF'
                    {...props}
                >
                    <path d='M19.4717 34.48H12.3971C11.6317 34.48 10.9971 33.8454 10.9971 33.08V23.5227C10.9971 21.5814 12.5837 19.9947 14.525 19.9947H19.4717C20.237 19.9947 20.8717 20.6294 20.8717 21.3947V33.0614C20.8717 33.8454 20.237 34.48 19.4717 34.48ZM13.7971 31.68H18.0717V22.8134H14.525C14.133 22.8134 13.7971 23.1306 13.7971 23.5413V31.68Z' />
                    <path d='M26.5284 34.4801H19.4537C18.6884 34.4801 18.0537 33.8454 18.0537 33.0801V15.048C18.0537 13.1067 19.6403 11.52 21.5817 11.52H24.4191C26.3604 11.52 27.947 13.1067 27.947 15.048V33.0801C27.9284 33.8454 27.3124 34.4801 26.5284 34.4801ZM20.8723 31.6801H25.147V15.048C25.147 14.656 24.8297 14.32 24.4191 14.32H21.5817C21.1897 14.32 20.8537 14.6373 20.8537 15.048V31.6801H20.8723Z' />
                    <path d='M33.603 34.48H26.5284C25.7631 34.48 25.1284 33.8453 25.1284 33.08V24.5866C25.1284 23.8213 25.7631 23.1866 26.5284 23.1866H31.4751C33.4164 23.1866 35.003 24.7733 35.003 26.7146V33.08C35.003 33.8453 34.387 34.48 33.603 34.48ZM27.9284 31.68H32.203V26.7146C32.203 26.3226 31.8857 25.9866 31.4751 25.9866H27.9284V31.68Z' />
                    <path d='M28.6 43.0666H17.4C7.26402 43.0666 2.93335 38.736 2.93335 28.6V17.4C2.93335 7.26396 7.26402 2.93329 17.4 2.93329H28.6C38.736 2.93329 43.0667 7.26396 43.0667 17.4V28.6C43.0667 38.736 38.736 43.0666 28.6 43.0666ZM17.4 5.73329C8.79468 5.73329 5.73335 8.79462 5.73335 17.4V28.6C5.73335 37.2053 8.79468 40.2666 17.4 40.2666H28.6C37.2053 40.2666 40.2667 37.2053 40.2667 28.6V17.4C40.2667 8.79462 37.2053 5.73329 28.6 5.73329H17.4Z' />
                </svg>
            )}
            {archiveBook && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='46'
                    height='46'
                    viewBox='0 0 46 46'
                    fill='#7AB3FF'
                    {...props}
                >
                    <path d='M30.4667 43.0666H15.5334C8.72005 43.0666 4.80005 39.1466 4.80005 32.3333V13.6666C4.80005 6.85329 8.72005 2.93329 15.5334 2.93329H30.4667C37.28 2.93329 41.2 6.85329 41.2 13.6666V32.3333C41.2 39.1466 37.28 43.0666 30.4667 43.0666ZM15.5334 5.73329C10.1947 5.73329 7.60005 8.32796 7.60005 13.6666V32.3333C7.60005 37.672 10.1947 40.2666 15.5334 40.2666H30.4667C35.8054 40.2666 38.4 37.672 38.4 32.3333V13.6666C38.4 8.32796 35.8054 5.73329 30.4667 5.73329H15.5334Z' />
                    <path d='M17.4 21.3386C17.0827 21.3386 16.7653 21.2826 16.4667 21.152C15.608 20.7786 15.0667 19.9386 15.0667 19.0239V4.33329C15.0667 3.56796 15.7013 2.93329 16.4667 2.93329H29.5333C30.2986 2.93329 30.9333 3.56796 30.9333 4.33329V19.0053C30.9333 19.9386 30.392 20.7786 29.5333 21.1333C28.6933 21.5066 27.704 21.3387 27.0134 20.704L23 17.0266L18.9866 20.7227C18.5386 21.1333 17.9787 21.3386 17.4 21.3386ZM23 14.0587C23.56 14.0587 24.1386 14.2639 24.5866 14.6746L28.1333 17.9412V5.73329H17.8667V17.9412L21.4134 14.6746C21.8614 14.2639 22.44 14.0587 23 14.0587Z' />
                    <path d='M33.2667 28.1333H25.3333C24.568 28.1333 23.9333 27.4986 23.9333 26.7333C23.9333 25.968 24.568 25.3333 25.3333 25.3333H33.2667C34.032 25.3333 34.6667 25.968 34.6667 26.7333C34.6667 27.4986 34.032 28.1333 33.2667 28.1333Z' />
                    <path d='M33.2667 35.6H17.4C16.6347 35.6 16 34.9653 16 34.2C16 33.4347 16.6347 32.8 17.4 32.8H33.2667C34.032 32.8 34.6667 33.4347 34.6667 34.2C34.6667 34.9653 34.032 35.6 33.2667 35.6Z' />
                </svg>
            )}

            {trackCode && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='22'
                    height='22'
                    viewBox='0 0 22 22'
                    fill='#B9B9B9'
                    {...props}
                >
                    <path d='M7 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V15C2 14.7348 1.89464 14.4804 1.70711 14.2929C1.51957 14.1054 1.26522 14 1 14C0.734784 14 0.48043 14.1054 0.292893 14.2929C0.105357 14.4804 0 14.7348 0 15V19C0 19.7956 0.31607 20.5587 0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22H7C7.26522 22 7.51957 21.8946 7.70711 21.7071C7.89464 21.5196 8 21.2652 8 21C8 20.7348 7.89464 20.4804 7.70711 20.2929C7.51957 20.1054 7.26522 20 7 20ZM21 14C20.7348 14 20.4804 14.1054 20.2929 14.2929C20.1054 14.4804 20 14.7348 20 15V19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H15C14.7348 20 14.4804 20.1054 14.2929 20.2929C14.1054 20.4804 14 20.7348 14 21C14 21.2652 14.1054 21.5196 14.2929 21.7071C14.4804 21.8946 14.7348 22 15 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V15C22 14.7348 21.8946 14.4804 21.7071 14.2929C21.5196 14.1054 21.2652 14 21 14ZM19 0H15C14.7348 0 14.4804 0.105357 14.2929 0.292893C14.1054 0.48043 14 0.734784 14 1C14 1.26522 14.1054 1.51957 14.2929 1.70711C14.4804 1.89464 14.7348 2 15 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3V7C20 7.26522 20.1054 7.51957 20.2929 7.70711C20.4804 7.89464 20.7348 8 21 8C21.2652 8 21.5196 7.89464 21.7071 7.70711C21.8946 7.51957 22 7.26522 22 7V3C22 2.20435 21.6839 1.44129 21.1213 0.87868C20.5587 0.31607 19.7956 0 19 0ZM1 8C1.26522 8 1.51957 7.89464 1.70711 7.70711C1.89464 7.51957 2 7.26522 2 7V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H7C7.26522 2 7.51957 1.89464 7.70711 1.70711C7.89464 1.51957 8 1.26522 8 1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V7C0 7.26522 0.105357 7.51957 0.292893 7.70711C0.48043 7.89464 0.734784 8 1 8ZM9 4H5C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V9C4 9.26522 4.10536 9.51957 4.29289 9.70711C4.48043 9.89464 4.73478 10 5 10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9V5C10 4.73478 9.89464 4.48043 9.70711 4.29289C9.51957 4.10536 9.26522 4 9 4ZM8 8H6V6H8V8ZM13 10H17C17.2652 10 17.5196 9.89464 17.7071 9.70711C17.8946 9.51957 18 9.26522 18 9V5C18 4.73478 17.8946 4.48043 17.7071 4.29289C17.5196 4.10536 17.2652 4 17 4H13C12.7348 4 12.4804 4.10536 12.2929 4.29289C12.1054 4.48043 12 4.73478 12 5V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10ZM14 6H16V8H14V6ZM9 12H5C4.73478 12 4.48043 12.1054 4.29289 12.2929C4.10536 12.4804 4 12.7348 4 13V17C4 17.2652 4.10536 17.5196 4.29289 17.7071C4.48043 17.8946 4.73478 18 5 18H9C9.26522 18 9.51957 17.8946 9.70711 17.7071C9.89464 17.5196 10 17.2652 10 17V13C10 12.7348 9.89464 12.4804 9.70711 12.2929C9.51957 12.1054 9.26522 12 9 12ZM8 16H6V14H8V16ZM13 15C13.2652 15 13.5196 14.8946 13.7071 14.7071C13.8946 14.5196 14 14.2652 14 14C14.2652 14 14.5196 13.8946 14.7071 13.7071C14.8946 13.5196 15 13.2652 15 13C15 12.7348 14.8946 12.4804 14.7071 12.2929C14.5196 12.1054 14.2652 12 14 12H13C12.7348 12 12.4804 12.1054 12.2929 12.2929C12.1054 12.4804 12 12.7348 12 13V14C12 14.2652 12.1054 14.5196 12.2929 14.7071C12.4804 14.8946 12.7348 15 13 15ZM17 12C16.7348 12 16.4804 12.1054 16.2929 12.2929C16.1054 12.4804 16 12.7348 16 13V16C15.7348 16 15.4804 16.1054 15.2929 16.2929C15.1054 16.4804 15 16.7348 15 17C15 17.2652 15.1054 17.5196 15.2929 17.7071C15.4804 17.8946 15.7348 18 16 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V13C18 12.7348 17.8946 12.4804 17.7071 12.2929C17.5196 12.1054 17.2652 12 17 12ZM13 16C12.8022 16 12.6089 16.0586 12.4444 16.1685C12.28 16.2784 12.1518 16.4346 12.0761 16.6173C12.0004 16.8 11.9806 17.0011 12.0192 17.1951C12.0578 17.3891 12.153 17.5673 12.2929 17.7071C12.4327 17.847 12.6109 17.9422 12.8049 17.9808C12.9989 18.0194 13.2 17.9996 13.3827 17.9239C13.5654 17.8482 13.7216 17.72 13.8315 17.5556C13.9414 17.3911 14 17.1978 14 17C14 16.7348 13.8946 16.4804 13.7071 16.2929C13.5196 16.1054 13.2652 16 13 16Z' />
                </svg>
            )}
            {phone && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='22'
                    height='22'
                    viewBox='0 0 22 22'
                    fill='none'
                    stroke='white'
                    strokeWidth='1.5'
                    {...props}
                >
                    <path
                        d='M20.97 17.33C20.97 17.69 20.89 18.06 20.72 18.42C20.55 18.78 20.33 19.12 20.04 19.44C19.55 19.98 19.01 20.37 18.4 20.62C17.8 20.87 17.15 21 16.45 21C15.43 21 14.34 20.76 13.19 20.27C12.04 19.78 10.89 19.12 9.75 18.29C8.6 17.45 7.51 16.52 6.47 15.49C5.44 14.45 4.51 13.36 3.68 12.22C2.86 11.08 2.2 9.94 1.72 8.81C1.24 7.67 1 6.58 1 5.54C1 4.86 1.12 4.21 1.36 3.61C1.6 3 1.98 2.44 2.51 1.94C3.15 1.31 3.85 1 4.59 1C4.87 1 5.15 1.06 5.4 1.18C5.66 1.3 5.89 1.48 6.07 1.74L8.39 5.01C8.57 5.26 8.7 5.49 8.79 5.71C8.88 5.92 8.93 6.13 8.93 6.32C8.93 6.56 8.86 6.8 8.72 7.03C8.59 7.26 8.4 7.5 8.16 7.74L7.4 8.53C7.29 8.64 7.24 8.77 7.24 8.93C7.24 9.01 7.25 9.08 7.27 9.16C7.3 9.24 7.33 9.3 7.35 9.36C7.53 9.69 7.84 10.12 8.28 10.64C8.73 11.16 9.21 11.69 9.73 12.22C10.27 12.75 10.79 13.24 11.32 13.69C11.84 14.13 12.27 14.43 12.61 14.61C12.66 14.63 12.72 14.66 12.79 14.69C12.87 14.72 12.95 14.73 13.04 14.73C13.21 14.73 13.34 14.67 13.45 14.56L14.21 13.81C14.46 13.56 14.7 13.37 14.93 13.25C15.16 13.11 15.39 13.04 15.64 13.04C15.83 13.04 16.03 13.08 16.25 13.17C16.47 13.26 16.7 13.39 16.95 13.56L20.26 15.91C20.52 16.09 20.7 16.3 20.81 16.55C20.91 16.8 20.97 17.05 20.97 17.33Z'
                        strokeMiterlimit='10'
                    />
                </svg>
            )}

            {close && (
                <svg
                    className='w-4 h-4'
                    fill='currentColor'
                    viewBox='0 0 20 20'
                    xmlns='http://www.w3.org/2000/svg'
                    {...props}
                >
                    <path
                        fillRule='evenodd'
                        d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                        clipRule='evenodd'
                    ></path>
                </svg>
            )}
            {massage && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='white'
                    strokeWidth='1.5'
                    {...props}
                >
                    <path
                        d='M18.4701 16.83L18.8601 19.99C18.9601 20.82 18.0701 21.4 17.3601 20.97L13.1701 18.48C12.7101 18.48 12.2601 18.45 11.8201 18.39C12.5601 17.52 13.0001 16.42 13.0001 15.23C13.0001 12.39 10.5401 10.09 7.50009 10.09C6.34009 10.09 5.2701 10.42 4.3801 11C4.3501 10.75 4.34009 10.5 4.34009 10.24C4.34009 5.68999 8.29009 2 13.1701 2C18.0501 2 22.0001 5.68999 22.0001 10.24C22.0001 12.94 20.6101 15.33 18.4701 16.83Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M13 15.2298C13 16.4198 12.56 17.5198 11.82 18.3898C10.83 19.5898 9.26 20.3598 7.5 20.3598L4.89 21.9098C4.45 22.1798 3.89 21.8098 3.95 21.2998L4.2 19.3298C2.86 18.3998 2 16.9098 2 15.2298C2 13.4698 2.94 11.9198 4.38 10.9998C5.27 10.4198 6.34 10.0898 7.5 10.0898C10.54 10.0898 13 12.3898 13 15.2298Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {charge && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    id='iconCharge'
                    width='24'
                    height='29'
                    viewBox='0 0 24 29'
                    fill='none'
                    stroke='#8A8A8A'
                    {...props}
                >
                    <path
                        d='M23 7.75V21.25C23 26.65 21.625 28 16.125 28H7.875C2.375 28 1 26.65 1 21.25V7.75C1 2.35 2.375 1 7.875 1H16.125C21.625 1 23 2.35 23 7.75Z'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M14.75 5.7251H9.25'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M11.9999 24.0849C13.177 24.0849 14.1312 23.1481 14.1312 21.9924C14.1312 20.8367 13.177 19.8999 11.9999 19.8999C10.8228 19.8999 9.86865 20.8367 9.86865 21.9924C9.86865 23.1481 10.8228 24.0849 11.9999 24.0849Z'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {arrowDown && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#292D32'
                    {...props}
                >
                    <path
                        d='M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {arrowUp && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='9'
                    viewBox='0 0 18 9'
                    fill='none'
                    stroke='#197BFF'
                    {...props}
                >
                    <path
                        d='M1.07992 8.05005L7.59992 1.53005C8.36992 0.760048 9.62992 0.760048 10.3999 1.53005L16.9199 8.05005'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {arrowRight && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#197BFF'
                    strokeWidth='1.5'
                    {...props}
                >
                    <path
                        d='M14.4299 5.92993L20.4999 11.9999L14.4299 18.0699'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M3.5 12H20.33'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {bar && (
                <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    stroke='#292D32'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path d='M3 7H21' strokeWidth='1.5' strokeLinecap='round' />
                    <path
                        d='M3 12H21'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                    />
                    <path
                        d='M3 17H21'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                    />
                </svg>
            )}
            {tickCircle && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    strokeWidth='1.5'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#197BFF'
                    {...props}
                >
                    <path
                        d='M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.75 12L10.58 14.83L16.25 9.17004'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {edit && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#197BFF'
                    {...props}
                >
                    <path
                        d='M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M16.0399 3.02001L8.15988 10.9C7.85988 11.2 7.55988 11.79 7.49988 12.22L7.06988 15.23C6.90988 16.32 7.67988 17.08 8.76988 16.93L11.7799 16.5C12.1999 16.44 12.7899 16.14 13.0999 15.84L20.9799 7.96001C22.3399 6.60001 22.9799 5.02001 20.9799 3.02001C18.9799 1.02001 17.3999 1.66001 16.0399 3.02001Z'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M14.9102 4.1499C15.5802 6.5399 17.4502 8.4099 19.8502 9.0899'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {add && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='40'
                    height='40'
                    viewBox='0 0 40 40'
                    fill='none'
                    stroke='#197BFF'
                    {...props}
                >
                    <path
                        d='M10 20H30'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M20 30V10'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {note && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#292D32'
                    strokeWidth='1.5'
                    {...props}
                >
                    <path
                        d='M8 2V5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M16 2V5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7 13H15'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7 17H12'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M16 3.5C19.33 3.68 21 4.95 21 9.65V15.83C21 19.95 20 22.01 15 22.01H9C4 22.01 3 19.95 3 15.83V9.65C3 4.95 4.67 3.69 8 3.5H16Z'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {bill && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#383838'
                    strokeWidth='1.5'
                    {...props}
                >
                    <path
                        d='M3.67004 2.5V14.47C3.67004 15.45 4.13004 16.38 4.92004 16.97L10.13 20.87C11.24 21.7 12.77 21.7 13.88 20.87L19.09 16.97C19.88 16.38 20.34 15.45 20.34 14.47V2.5H3.67004Z'
                        strokeMiterlimit='10'
                    />
                    <path
                        d='M2 2.5H22'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                    />
                    <path
                        d='M8 8H16'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M8 13H16'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {infoCircle && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#292D32'
                    strokeWidth='2'
                    {...props}
                >
                    <path
                        d='M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M12 8V13'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M11.9945 16H12.0035'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {logout && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#292D32'
                    strokeWidth='1.5'
                    {...props}
                >
                    <path
                        d='M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M15 12H3.62'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M5.85 8.65002L2.5 12L5.85 15.35'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {profileUser && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#292D32'
                    strokeWidth='1.5'
                    {...props}
                >
                    <path
                        d='M12.12 12.78C12.05 12.77 11.96 12.77 11.88 12.78C10.12 12.72 8.71997 11.28 8.71997 9.50998C8.71997 7.69998 10.18 6.22998 12 6.22998C13.81 6.22998 15.28 7.69998 15.28 9.50998C15.27 11.28 13.88 12.72 12.12 12.78Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M18.74 19.3801C16.96 21.0101 14.6 22.0001 12 22.0001C9.40001 22.0001 7.04001 21.0101 5.26001 19.3801C5.36001 18.4401 5.96001 17.5201 7.03001 16.8001C9.77001 14.9801 14.25 14.9801 16.97 16.8001C18.04 17.5201 18.64 18.4401 18.74 19.3801Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {profileCircle && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='40'
                    height='40'
                    viewBox='0 0 40 40'
                    fill='none'
                    stroke='#383838'
                    strokeWidth='1.5'
                    {...props}
                >
                    <path
                        d='M20.2001 21.3C20.0834 21.2833 19.9334 21.2833 19.8001 21.3C16.8668 21.2 14.5334 18.8 14.5334 15.85C14.5334 12.8333 16.9668 10.3833 20.0001 10.3833C23.0168 10.3833 25.4668 12.8333 25.4668 15.85C25.4501 18.8 23.1334 21.2 20.2001 21.3Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M31.2333 32.3001C28.2666 35.0168 24.3333 36.6668 19.9999 36.6668C15.6666 36.6668 11.7333 35.0168 8.7666 32.3001C8.93327 30.7334 9.93327 29.2001 11.7166 28.0001C16.2833 24.9668 23.7499 24.9668 28.2833 28.0001C30.0666 29.2001 31.0666 30.7334 31.2333 32.3001Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M19.9999 36.6666C29.2047 36.6666 36.6666 29.2047 36.6666 19.9999C36.6666 10.7952 29.2047 3.33325 19.9999 3.33325C10.7952 3.33325 3.33325 10.7952 3.33325 19.9999C3.33325 29.2047 10.7952 36.6666 19.9999 36.6666Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {eyeSplash && (
                <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#B9B9B9'
                    strokeWidth='1.5'
                    xmlns='http://www.w3.org/2000/svg'
                    {...props}
                >
                    <path
                        d='M14.5299 9.46998L9.46992 14.53C8.81992 13.88 8.41992 12.99 8.41992 12C8.41992 10.02 10.0199 8.41998 11.9999 8.41998C12.9899 8.41998 13.8799 8.81998 14.5299 9.46998Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M17.8201 5.76998C16.0701 4.44998 14.0701 3.72998 12.0001 3.72998C8.47009 3.72998 5.18009 5.80998 2.89009 9.40998C1.99009 10.82 1.99009 13.19 2.89009 14.6C3.68009 15.84 4.60009 16.91 5.60009 17.77'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M8.41992 19.53C9.55992 20.01 10.7699 20.27 11.9999 20.27C15.5299 20.27 18.8199 18.19 21.1099 14.59C22.0099 13.18 22.0099 10.81 21.1099 9.39999C20.7799 8.87999 20.4199 8.38999 20.0499 7.92999'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M9.47 14.53L2 22'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M22 2L14.53 9.47'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {eye && (
                <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#B9B9B9'
                    strokeWidth='1.5'
                    xmlns='http://www.w3.org/2000/svg'
                    {...props}
                >
                    <path
                        d='M15.5799 12C15.5799 13.98 13.9799 15.58 11.9999 15.58C10.0199 15.58 8.41992 13.98 8.41992 12C8.41992 10.02 10.0199 8.41998 11.9999 8.41998C13.9799 8.41998 15.5799 10.02 15.5799 12Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M12.0001 20.27C15.5301 20.27 18.8201 18.19 21.1101 14.59C22.0101 13.18 22.0101 10.81 21.1101 9.39997C18.8201 5.79997 15.5301 3.71997 12.0001 3.71997C8.47009 3.71997 5.18009 5.79997 2.89009 9.39997C1.99009 10.81 1.99009 13.18 2.89009 14.59C5.18009 18.19 8.47009 20.27 12.0001 20.27Z'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )}
            {sms && (
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    {...props}
                >
                    <path
                        d='M16.32 20.8799H6.71995C3.21595 20.8799 1.19995 18.8639 1.19995 15.3599V8.63987C1.19995 5.13587 3.21595 3.11987 6.71995 3.11987H16.32C19.824 3.11987 21.84 5.13587 21.84 8.63987V15.3599C21.84 18.8639 19.824 20.8799 16.32 20.8799ZM6.71995 4.55987C3.97435 4.55987 2.63995 5.89427 2.63995 8.63987V15.3599C2.63995 18.1055 3.97435 19.4399 6.71995 19.4399H16.32C19.0656 19.4399 20.4 18.1055 20.4 15.3599V8.63987C20.4 5.89427 19.0656 4.55987 16.32 4.55987H6.71995Z'
                        fill='white'
                    />
                    <path
                        d='M11.5197 12.8351C10.7133 12.8351 9.89727 12.5855 9.27327 12.0767L6.26847 9.67669C5.96127 9.42709 5.90367 8.97588 6.15327 8.66868C6.40287 8.36148 6.85408 8.30389 7.16128 8.55349L10.1661 10.9535C10.8957 11.5391 12.1341 11.5391 12.8637 10.9535L15.8685 8.55349C16.1757 8.30389 16.6365 8.35188 16.8765 8.66868C17.1261 8.97588 17.0781 9.43669 16.7613 9.67669L13.7565 12.0767C13.1421 12.5855 12.3261 12.8351 11.5197 12.8351Z'
                        fill='white'
                    />
                </svg>
            )}
        </>
    );
};
